import Home from './page/Home';
import Navbar from './components/Navbar';




function App() {
  return (
    <div className="App">
      <Navbar />
      <Home />
    </div>
  );
}

export default App;
